import * as ko from "knockout";
import {IStepParams} from "./index";
import {ErrorTracker} from "../../../error.tracker";
import {global} from "../../../appContext";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {Settings} from "./Settings";
import {RuleMutable} from "./RuleMutable";

export abstract class AbstractStep {
    protected readonly et: ErrorTracker = global.errorAreas.get("rules.wizard");
    protected settings: Settings;
    protected kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    protected abstract ruleMutable: RuleMutable;

    constructor(protected params: IStepParams) {
        this.settings = params.settings;
    }

    protected isValidRuleSelection = ko.pureComputed((): boolean => {
        return this.ruleMutable.isValid() ?? false;
    })

    protected abstract validate(): boolean;

    protected doValidation() {
        this.settings.isValid(this.validate());
    }

   dispose() {
        this.kosub.unsuscribeAll();
    }

}